module.exports = __webpack_public_path__ + "media/images/features/draft/icon-flow-05-53c4b79a2436538747f6d9aedad821d3.svg";